import { ApplicationCogOutlineIcon } from './ApplicationCogOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A3B1663D-87F0-4E57-BAF4-5CB9D0CC6B17
 * name application-cog-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-cog-outline.svg
 * tags
 * - Settings 
 */
export const IframeCogOutlineIcon = ApplicationCogOutlineIcon;
export default IframeCogOutlineIcon